import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService {
  parsedToken: any;
  authenticated: boolean = false;
  currentUser: any;

  constructor(public router: Router) {
    const token = this.getToken();
    if (token !== null && this.parsedToken == null) {
      this.parsedToken = jwtDecode(token);
    }
  }

  //Instead of reading directly from localStorage, use a shared service with a BehaviorSubject to manage and track the state of isLoggedIn.
  private loggedIn = new BehaviorSubject<boolean>(this.isLoggedInFromLocalStorage());
  isLoggedIn$: Observable<boolean> = this.loggedIn.asObservable();

  private isLoggedInFromLocalStorage(): boolean {
    return sessionStorage.getItem(environment.IS_LOGGED_IN_FLAG) === 'true';
  }

  getToken() {
    return sessionStorage.getItem(environment.ACCESS_TOKEN);
  }

  setAuthentication(accessToken: string) {
    sessionStorage.setItem(environment.ACCESS_TOKEN, accessToken);
    this.authenticated = true;
  }

  login(): void {
    this.loggedIn.next(true);
    sessionStorage.setItem(environment.IS_LOGGED_IN_FLAG, 'true');
  }

  clearSessionAndResetState(): void {
    sessionStorage.removeItem(environment.ACCESS_TOKEN);
    this.loggedIn.next(false);
    sessionStorage.setItem(environment.IS_LOGGED_IN_FLAG, 'false');
    this.authenticated = false;
    this.currentUser = null;
    sessionStorage.removeItem('appUser_id');
    sessionStorage.removeItem('specialty_code');
    sessionStorage.removeItem('vdoc-examinationDetails');
  }

  logout(): void {
    this.clearSessionAndResetState();
    this.router.navigate(['/']);
  }
}
